// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2Bdh-","head":"ProcedureTableInfo_head__2G2Sm"};